export const ZMANIM_WIDTH = 1200;
export const ZMANIM_HEIGHT = 1920;
